import { HiOutlineMail } from "react-icons/hi";
import { FaWhatsapp } from "react-icons/fa";

const data = [
  {
    id: 1,
    icon: <HiOutlineMail />,
    link: "mailto:vinicius.ts.online@gmail.com",
  },
  { id: 3, icon: <FaWhatsapp />, link: "https://wa.me/+5564992013628" },
];

// alternative whatsApp link
// https://wa.me/yournumber
// https://api.whatsapp.com/send/?phone=%2B233557097546

export default data;
